import { Alert } from "components/elements";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import * as services from "../service/pendingApprovalApi";
import { setIsLoading } from "../slices/requestApprovalSlice";

function useRequestApproveOption() {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();
    const [lang, setLang] = useState("en");
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);

    //* options
    const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [offSiteOptions, setOffSiteOptions] = useState([]);
    const [penaltiesOptions, setPenaltiesOptions] = useState([]);
    const [companyRegulationOptions, setCompanyRegulationOptions] = useState([]);

    const modifiedLeaveGroupOptions = useMemo(() => {
        return leaveGroupOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.leaveTypeNameEn : opt.leaveTypeName,
            value: opt.leaveId,
        }));
    }, [lang, leaveGroupOptions]);

    const getLeaveGroupOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                };
                const response = await services.getLeaveGroupIsLeaveApproval(values);
                setLeaveGroupOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);


    const modifiedEmployeeOptions = useMemo(() => {
        return employeeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.fullNameEn : opt.fullName,
            value: opt.id,
        }));
    }, [lang, employeeOptions]);

    const getEmployeeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getDropDown(values);
                setEmployeeOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    const getOffSiteOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                };
                const response = await services.getLeaveGroupIsOffSite(
                    values
                );
                setOffSiteOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    const getCompanyRegulationOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getCompanyRegulationOptions(
                    values
                );
                setCompanyRegulationOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);
    const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

    const modifiedDocumentTypeOptions = useMemo(() => {
        return documentTypeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, documentTypeOptions]);

    const getDocumentTypeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = { requestId: generateRandomString(), companyId: currentCompany };
                const response = await services.getDocumentTypeOptions(values);
                setDocumentTypeOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        if (currentCompany) {
            getDocumentTypeOptions();
        }
    }, [getDocumentTypeOptions]);
    const getPenaltiesOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getPenaltiesOptions(values);
                setPenaltiesOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    // useEffect(() => {
    //     if (currentCompany) {
    //         getLeaveGroupOptions();
    //     }
    // }, [getLeaveGroupOptions])

    useEffect(() => {
        if (currentCompany) {
            getEmployeeOptions();
        }
    }, [getEmployeeOptions])

    // useEffect(() => {
    //     if (currentCompany) {
    //         getOffSiteOptions();
    //     }
    // }, [getOffSiteOptions])

    // useEffect(() => {
    //     if (currentCompany) {
    //         getCompanyRegulationOptions();
    //     }
    // }, [getCompanyRegulationOptions])

    // useEffect(() => {
    //     if (currentCompany) {
    //         getPenaltiesOptions();
    //     }
    // }, [getPenaltiesOptions]);

    const modifiedPenaltiesOptions = useMemo(() => {
        return penaltiesOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, penaltiesOptions]);

    const modifiedCompanyRegulationOptions = useMemo(() => {
        return companyRegulationOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, companyRegulationOptions]);

    const modifiedOffSiteOptions = useMemo(() => {
        return offSiteOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, offSiteOptions]);


    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language, setLang]);


    return {
        modifiedOffSiteOptions,
        modifiedEmployeeOptions,
        modifiedLeaveGroupOptions,
        modifiedCompanyRegulationOptions,
        modifiedDocumentTypeOptions,
        modifiedPenaltiesOptions,
        leaveGroupOptions,
        getOffSiteOptions,
        getCompanyRegulationOptions,
        getDocumentTypeOptions,
        getPenaltiesOptions,
    }

}
export default useRequestApproveOption